import { CommentListRe, IconButton, Text } from 'components'
import { useState } from 'react'
import { useRecoilValue } from 'recoil'
import { userInfoState } from 'store/atom/user-state-atom'

// css
import 'assets/style/components/comment-list.scss'
import useModal from 'hook/useModal'
import { isEmptyString } from 'utils/common-util'
import { getMessage } from 'utils/message-util'

function Element({
  comment = { cmntCn: '', replyList: [], regrId: '', regDttm: '' },
  dispAuthor = true,
  registMutation,
  updateMutation,
  deleteMutation,
}) {
  const { alertModal, confirmModal, closeModal } = useModal()
  const userInfo = useRecoilValue(userInfoState)

  const [isShow, setIsShow] = useState(false)
  const [isReply, setIsReply] = useState(false)
  const [isModify, setIsModify] = useState(false)
  const [replyCn, setReplyCn] = useState('')
  const [modifyCn, setModifyCn] = useState('')

  const toggleReply = () => {
    setIsShow(false)
    setIsModify(false)
    setIsReply((prev) => {
      setReplyCn('')
      return !prev
    })
  }

  const toggleModify = () => {
    setIsShow(false)
    setIsReply(false)
    setIsModify((prev) => {
      if (!prev) {
        setModifyCn(comment.cmntCn)
      }
      return !prev
    })
  }

  const registReply = (data) => {
    if (isEmptyString(data.cmntCn)) {
      alertModal(getMessage('common_validation_004', { target: '댓글' }))
      return
    }
    data.useYn = 'Y'
    data.regrId = userInfo.userId
    registMutation.mutate(data)
    setIsReply(false)
    setReplyCn('')
  }

  const modifyReply = (data, callback) => {
    if (isEmptyString(data.cmntCn)) {
      alertModal(getMessage('common_validation_004', { target: '댓글' }))
      return
    }
    updateMutation.mutate(data)
    setIsModify(false)
    setModifyCn('')
    if (callback) callback()
  }

  const deleteReply = (data, callback) => {
    confirmModal('삭제 하시겠습니까?', () => {
      closeModal()
      deleteMutation.mutate(data)
      setIsModify(false)
      if (callback) callback()
    })
  }
  return (
    <>
      <ul className="comment-list">
        <li>
          <div className="flex-between">
            <div className="comment-list-info">
              {(dispAuthor || comment?.magrRegYn === 'Y') && (
                <Text className="f-12 c-6">
                  {comment.regrNm}[{comment.deptNm}]
                </Text>
              )}
              <Text className="f-12 date">{comment.regDttm}</Text>
            </div>

            {/* more button 클릭 시 삭제/수정 노출 (김정웅)  */}
            {userInfo.userId === comment.regrId && comment.useYn === 'Y' && (
              <div className="more-area">
                <IconButton
                  type="more"
                  size="20"
                  onClick={() => {
                    setIsReply(false)
                    setIsModify(false)
                    setIsShow((prev) => {
                      return !prev
                    })
                  }}
                />
                {isShow ? (
                  <>
                    <div className="popup-dim" style={{ opacity: '0' }} onClick={() => setIsShow(false)}></div>
                    <div className="floating-menu" style={{ zIndex: '12' }}>
                      <span onClick={() => deleteReply(comment)}>삭제</span>
                      <span onClick={toggleModify}>수정</span>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            )}
          </div>
          {isModify ? (
            <div className="reply-form flex mt16">
              <div className={'input-text-wrap'}>
                <input
                  tabIndex="-1"
                  value={modifyCn}
                  onChange={(e) => {
                    setModifyCn(e.target.value)
                  }}
                  onKeyUp={(e) => {
                    console.log(e)
                  }}
                  onKeyDown={(e) => {
                    console.log(e)
                    if (e.key === 'Enter') {
                      modifyReply({ ...comment, cmntCn: modifyCn })
                    }
                  }}
                />
              </div>
              <IconButton type="write" size="20" onClick={() => modifyReply({ ...comment, cmntCn: modifyCn })} />
            </div>
          ) : (
            <>
              <Text
                className="mt8"
                onClick={() => {
                  setIsShow(false)
                }}
              >
                {comment.cmntCn}
              </Text>
            </>
          )}
          {isReply ? (
            <div className="reply-form flex mt16">
              <div className={'input-text-wrap'}>
                <input
                  tabIndex="-1"
                  placeholder="답글을 입력하세요."
                  value={replyCn}
                  onChange={(e) => {
                    setReplyCn(e.target.value)
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      registReply({ ntcAtclId: comment.ntcAtclId, hgrnkCmntId: comment.cmntId, cmntCn: replyCn })
                    }
                  }}
                />
              </div>
              <IconButton
                type="write"
                size="20"
                onClick={() =>
                  registReply({ ntcAtclId: comment.ntcAtclId, hgrnkCmntId: comment.cmntId, cmntCn: replyCn })
                }
              />
            </div>
          ) : (
            <></>
          )}
          {comment.replyList?.map((reply, index2) => (
            <CommentListRe
              reply={reply}
              dispAuthor={dispAuthor}
              onModify={modifyReply}
              onDelete={deleteReply}
              key={`reply_${index2}`}
            />
          ))}
          {comment.useYn === 'N' || isReply ? (
            <></>
          ) : (
            <Text className="comment-btn mt8" text="답글달기" onClick={toggleReply} style={{ margin: '0' }} />
          )}
        </li>
      </ul>

      {/* <Line size="1" color="gray" className="mt24" /> */}
    </>
  )
}

export default Element
